import { UPDATE_EMI_BANK, UPDATE_EMI_TENURE, UPDATE_EMI_SECTION } from 'actions/PaymentActions/emiStateActions';

export const INITIAL_STATE = {
	selectedBank: '',
	selectedBankEmiType: '',
	selectedTenure: '',
	selectedSection: '',
	selectedSectionKey: ''
};

// TODO: Add more robust check directly in the reducer instead of depending on
// the selected data.
export function isEmi(emiState = {}) {
	return emiState.selectedSection !== '';
}

// This is needed because the adjustments data is needed in parent
export default function emiStateReducer(state = INITIAL_STATE, action) {
	switch (action.type) {
		case UPDATE_EMI_BANK:
			return {
				...state,
				selectedBank: action.bankCode,
				selectedBankEmiType: action.bankEmiType,
				selectedBankKey: action.bankEmiKey,
				selectedBankName: action.bankName,
				shouldOpen2FASection: action.shouldOpen2FASection
			};
		case UPDATE_EMI_TENURE:
			return { ...state, selectedTenure: action.tenure };
		case UPDATE_EMI_SECTION:
			return {
				...state,
				selectedSection: action.section,
				selectedSectionKey: action.key
			};
		default:
			return state;
	}
}
